import { cn } from '@/lib/utils'
import { useTile } from '../../context'
import TileWrapper from '../TileWrapper'
import { ExternalLink } from 'lucide-react'
import Card from 'app/frontend/base/components/Card'

interface CustomLink {
  label: string
  url: string
}

const CustomLinksTile = () => {
  const { tile } = useTile()
  const links = (tile.config?.links as CustomLink[]) || []

  if (links.length === 0) {
    return (
      <TileWrapper>
        <p className='text-muted-foreground'>No links configured.</p>
      </TileWrapper>
    )
  }

  const isSidebar = tile.position === 'sidebar'

  return (
    <TileWrapper>
      <div className={isSidebar ? 'space-y-1' : 'flex gap-4'}>
        {links.map((link, index) => (
          <Card
            key={index}
            className={
              isSidebar
                ? 'border-0 p-0 bg-transparent hover:bg-transparent'
                : 'flex-1 flex p-0 w-full items-center justify-center hover:text-primary'
            }
          >
            <a
              href={link.url}
              target='_blank'
              rel='noopener noreferrer'
              className={cn(
                isSidebar
                  ? 'inline-flex hover:text-primary'
                  : 'py-2 px-3 flex w-full h-full justify-center',
                'items-center gap-2 break-all transition-colors',
              )}
            >
              <ExternalLink className='h-3 w-3 min-h-3 min-w-3' />
              {link.label}
            </a>
          </Card>
        ))}
      </div>
    </TileWrapper>
  )
}

export default CustomLinksTile
